import React, { useEffect } from "react"

import { graphql, Link } from "gatsby"
import { inject, observer } from "mobx-react"

import { Wrapper } from "../../components/base/wrapper/wrapper"
import { SEO } from "../../components/base/seo/seo"
import { Alert } from "../../components/modules/alert/alert"
import { SampleLetterForm } from "./sample-letter-form/sample-letter-form"
import {
  isSafari,
  redirectToAppropriateRegionIfEw,
} from "../../helpers/helpers"

export default inject("regionStore")(
  observer(({ regionStore, data }) => {
    const {
      seoTitle,
      title,
      instructions,
      description,
      canonicalUrl,
      sampleLetterContent,
      validInEngland,
      validInScotland,
    } = data.wagtail.page

    const { isEngland, isScotland } = regionStore

    const isNotRelevantToRegion =
      (isEngland && !validInEngland) || (isScotland && !validInScotland)

    const submitForm = () => {
      // Check browser because window.print(); does not work on Safari.
      // See: https://stackoverflow.com/questions/23626998/safari-print-issue-with-javascript-window-print
      isSafari() ? document.execCommand("print", false, null) : window.print()
    }

    useEffect(() => {
      redirectToAppropriateRegionIfEw(isScotland)
    }, [])

    return (
      <Wrapper>
        <SEO
          title={`Sample Letter - ${seoTitle}`}
          description={description}
          canonical={canonicalUrl}
        />

        {isNotRelevantToRegion && (
          <Alert
            title="This letter is not relevant in your region"
            description={
              <>
                Sorry, this letter is not available in your region. Please go to
                the <Link to="/sample-letters">Sample Letters page</Link> to see
                letters relevant to your region.
              </>
            }
          />
        )}

        <SampleLetterForm
          title={title}
          description={description}
          instructions={instructions}
          isRelevantToCurrentRegion={!isNotRelevantToRegion}
          sampleLetterContent={sampleLetterContent}
          submitForm={submitForm}
        />
      </Wrapper>
    )
  })
)

export const query = graphql`
  query($slug: String) {
    wagtail {
      page(slug: $slug) {
        ... on SampleLetter {
          id
          seoTitle
          title
          instructions
          description
          canonicalUrl
          sampleLetterContent
          validInEngland
          validInScotland
        }
      }
    }
  }
`
